/**
 * Due diligence service - placeholder for future API integration.
 * When backend provides due diligence endpoints, implement getDueDiligenceCompanies here.
 */
import type { TDueDiligenceCompany } from "./dueDiligence.types";

export type TDueDiligenceCompaniesResult = {
  companies: TDueDiligenceCompany[];
  categories: string[];
};

/** Pipeline sector categories for filter chips - align with My Deal Pipeline when API available */
const DEFAULT_CATEGORIES = [
  "All",
  "Consumer Electronics",
  "Dating",
  "Education",
  "Energy",
  "Enterprise Software",
  "Event Tech",
  "Fashion",
  "Fintech",
  "Food",
  "Gaming",
  "Health",
];

/**
 * Fetch due diligence companies for an investor company.
 * Placeholder: returns empty data until backend API is available.
 */
export function getDueDiligenceCompanies(
  _companyId: string
): Promise<{ data: TDueDiligenceCompaniesResult; error: Error | null }> {
  return Promise.resolve({
    data: {
      companies: [],
      categories: DEFAULT_CATEGORIES,
    },
    error: null,
  });
}
